<div class="modal-header align-items-center">
  <h5 class="modal-title pull-left semibold">{{ 'notifications.titles.edit' | translate }}</h5>
  <button type="button" class="btn btn-icon" aria-label="Close" (click)="onClose()">
    <i class="icon-close icon-16"></i>
  </button>
</div>
<div class="modal-body">
  <p class="caption pt-2 pb-4">
    {{ 'notifications.form.label.publish_on' | translate }}:
    <span>{{ notification?.publishDate | dateFormat }}</span>
    <span class="dot m-2 text-gray semibold">&bull;</span>
    {{ 'notifications.form.label.publish_by' | translate }}: <span>{{ notification?.lastUpdatedByName }}</span>
  </p>

  <form class="flex flex-column" [formGroup]="form">
    <div class="mb-4">
      <label class="note semibold required">{{ 'notifications.form.label.end_date_and_time' | translate }}</label>
      <div class="d-flex align-items-center mt-2" [ngClass]="{ 'is-invalid': form.get('endDate').errors }">
        <gcc-datepicker bsDatepicker formControlName="endDate" [minDate]="currentDate"></gcc-datepicker>
        <gcc-timepicker formControlName="endDate" [minDate]="currentDate" class="mx-2"></gcc-timepicker>
        <div class="note text-gray">
          {{ timezone$ | async }}
        </div>
      </div>
      <div class="caption invalid-feedback mt-2">{{ 'common.validation.min_date' | translate }}</div>
    </div>
  </form>

  <div>
    <p class="caption semibold pb-2">{{ 'notifications.form.label.preview' | translate }}</p>
    <gcc-notification-item
      [notification]="notification"
      [preview]="true"
      [ngClass]="{ w396: notification.type !== notificationType['Urgent alert'] }"
    ></gcc-notification-item>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="onClose()">{{ 'common.buttons.cancel' | translate }}</button>
  <button type="button" class="btn btn-primary btn-form" (click)="handleAction()" [disabled]="form.invalid">
    {{ 'common.buttons.save' | translate }}
  </button>
</div>
